module.exports = __webpack_public_path__ + "img/image-2.19fc70e3.jpg";